import { trackByEvent, trackByPage } from '../../../tracking/services';
import { COMPONENT_TYPE, COOKIE_CONSENT } from '../../../tracking/constant';
import { COURIER_OVERVIEW_PAGE_TRACKING_EVENTS, TApplink, TFAQClick, TFAQScrollToBottom, TPageGetStarted, TPageView, } from './index'
import { CookieConsent } from '@takeaway/ui-vanilla';
import i18n, { defaultLang } from '@src/i18n';
import { isPWA } from '@src/shared/utils';
interface ITrackingArguments {
    country : string,
    language : string
}

export const trackGetStarted = (buttonNumber : number) => {
    try {
        const trackData : TPageGetStarted = {
            component_name: 'courier app overview',
            component_id: `BUTTON_${buttonNumber}`,
            component_type: COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.GET_STARTED.component_type as COMPONENT_TYPE,
            eventCategory:'',
            language:'',
            country: '',
            form_action:'submit'
        }
        trackByEvent<TPageGetStarted>(COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.GET_STARTED.event, trackData)
    } catch (error) {
        console.log('trackVideoStart error', error);
    }
}

export const trackPageView = ({country,language} : ITrackingArguments) => {
    const { pageGroup, url, siteType, restaurantId } = COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.PAGE_VIEW
    try {
        const trackData : TPageView = {
            pageGroup,
            url,
            siteType,
            restaurantId,
            cookieConsent: CookieConsent.getConsent() as COOKIE_CONSENT,
            country,
            language,
            pagePWA:JSON.stringify(isPWA())
        }
        trackByPage<TPageView>('courieroverview', trackData)
    } catch (error) {
        console.log('trackVideoStart error', error);
    }
}


export const trackAPPLink = ({country,language} : ITrackingArguments, linkType : string) => {
    const { component_name, form_action,component_type } = COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.APP_LINK
    try {
        const trackData : TApplink = {
            component_name,
            component_id : linkType,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory:'',
            language,
            country,
            form_action
        }
        trackByEvent<TApplink>(COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.GET_STARTED.event, trackData)
    } catch (error) {
        console.log('trackVideoStart error', error);
    }
}


export const trackFAQClick = (faqTitle: string, faqIndex: number) => {
    try {
        const { faq_action, component_type, event, pageGroup } = COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.FAQ_OPEN
        const trackData: TFAQClick = {
            component_name: `${faqTitle}`,
            component_id: `${faqIndex}`,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            faq_action,
            pageGroup
        }
        trackByEvent<TFAQClick>(event, trackData)
    } catch (error) {
        console.log('trackFAQClick error', error);
    }
}


export const trackScrollToBottom = () => {
    try {
        const { component_type, event, pageGroup } = COURIER_OVERVIEW_PAGE_TRACKING_EVENTS.FAQ_SCROLL_TO_BOTTOM
        const trackData: TFAQScrollToBottom = {
            component_name: ``,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            pageGroup
        }
        trackByEvent<TFAQScrollToBottom>(event, trackData)
    } catch (error) {
        console.log('trackScrollToBottom error', error);
    }
}